{
  "countries": {
    "AF": "Afghanistan",
    "AL": "Albania",
    "DZ": "Algeria",
    "UM": "Altre isole americane del Pacifico",
    "AD": "Andorra",
    "AO": "Angola",
    "AI": "Anguilla",
    "AQ": "Antartide",
    "AG": "Antigua e Barbuda",
    "SA": "Arabia Saudita",
    "AR": "Argentina",
    "AM": "Armenia",
    "AW": "Aruba",
    "AU": "Australia",
    "AT": "Austria",
    "AZ": "Azerbaigian",
    "BS": "Bahamas",
    "BH": "Bahrein",
    "BD": "Bangladesh",
    "BB": "Barbados",
    "BE": "Belgio",
    "BZ": "Belize",
    "BJ": "Benin",
    "BM": "Bermuda",
    "BT": "Bhutan",
    "BY": "Bielorussia",
    "BO": "Bolivia",
    "BA": "Bosnia ed Erzegovina",
    "BW": "Botswana",
    "BR": "Brasile",
    "BN": "Brunei",
    "BG": "Bulgaria",
    "BF": "Burkina Faso",
    "BI": "Burundi",
    "KH": "Cambogia",
    "CM": "Camerun",
    "CA": "Canada",
    "CV": "Capo Verde",
    "BQ": "Caraibi olandesi",
    "CZ": "Cechia",
    "EA": "Ceuta e Melilla",
    "TD": "Ciad",
    "CL": "Cile",
    "CN": "Cina",
    "CY": "Cipro",
    "VA": "Città del Vaticano",
    "CO": "Colombia",
    "KM": "Comore",
    "CD": "Congo - Kinshasa",
    "CG": "Congo-Brazzaville",
    "KP": "Corea del Nord",
    "KR": "Corea del Sud",
    "CI": "Costa d’Avorio",
    "CR": "Costa Rica",
    "HR": "Croazia",
    "CU": "Cuba",
    "CW": "Curaçao",
    "DK": "Danimarca",
    "DG": "Diego Garcia",
    "DM": "Dominica",
    "EC": "Ecuador",
    "EG": "Egitto",
    "SV": "El Salvador",
    "AE": "Emirati Arabi Uniti",
    "ER": "Eritrea",
    "EE": "Estonia",
    "ET": "Etiopia",
    "FJ": "Figi",
    "PH": "Filippine",
    "FI": "Finlandia",
    "FR": "Francia",
    "GA": "Gabon",
    "GM": "Gambia",
    "GE": "Georgia",
    "GS": "Georgia del Sud e Sandwich australi",
    "DE": "Germania",
    "GH": "Ghana",
    "JM": "Giamaica",
    "JP": "Giappone",
    "GI": "Gibilterra",
    "DJ": "Gibuti",
    "JO": "Giordania",
    "GR": "Grecia",
    "GD": "Grenada",
    "GL": "Groenlandia",
    "GP": "Guadalupa",
    "GU": "Guam",
    "GT": "Guatemala",
    "GG": "Guernsey",
    "GN": "Guinea",
    "GQ": "Guinea Equatoriale",
    "GW": "Guinea-Bissau",
    "GY": "Guyana",
    "GF": "Guyana francese",
    "HT": "Haiti",
    "HN": "Honduras",
    "IN": "India",
    "ID": "Indonesia",
    "IR": "Iran",
    "IQ": "Iraq",
    "IE": "Irlanda",
    "IS": "Islanda",
    "AC": "Isola Ascensione",
    "CX": "Isola Christmas",
    "IM": "Isola di Man",
    "NF": "Isola Norfolk",
    "AX": "Isole Åland",
    "IC": "Isole Canarie",
    "KY": "Isole Cayman",
    "CC": "Isole Cocos (Keeling)",
    "CK": "Isole Cook",
    "FO": "Isole Fær Øer",
    "FK": "Isole Falkland",
    "MP": "Isole Marianne settentrionali",
    "MH": "Isole Marshall",
    "PN": "Isole Pitcairn",
    "SB": "Isole Salomone",
    "TC": "Isole Turks e Caicos",
    "VI": "Isole Vergini Americane",
    "VG": "Isole Vergini Britanniche",
    "IL": "Israele",
    "IT": "Italia",
    "JE": "Jersey",
    "KZ": "Kazakistan",
    "KE": "Kenya",
    "KG": "Kirghizistan",
    "KI": "Kiribati",
    "XK": "Kosovo",
    "KW": "Kuwait",
    "LA": "Laos",
    "LS": "Lesotho",
    "LV": "Lettonia",
    "LB": "Libano",
    "LR": "Liberia",
    "LY": "Libia",
    "LI": "Liechtenstein",
    "LT": "Lituania",
    "LU": "Lussemburgo",
    "MK": "Macedonia del Nord",
    "MG": "Madagascar",
    "MW": "Malawi",
    "MY": "Malaysia",
    "MV": "Maldive",
    "ML": "Mali",
    "MT": "Malta",
    "MA": "Marocco",
    "MQ": "Martinica",
    "MR": "Mauritania",
    "MU": "Mauritius",
    "YT": "Mayotte",
    "MX": "Messico",
    "FM": "Micronesia",
    "MD": "Moldavia",
    "MC": "Monaco",
    "MN": "Mongolia",
    "ME": "Montenegro",
    "MS": "Montserrat",
    "MZ": "Mozambico",
    "MM": "Myanmar (Birmania)",
    "NA": "Namibia",
    "NR": "Nauru",
    "NP": "Nepal",
    "NI": "Nicaragua",
    "NE": "Niger",
    "NG": "Nigeria",
    "NU": "Niue",
    "NO": "Norvegia",
    "NC": "Nuova Caledonia",
    "NZ": "Nuova Zelanda",
    "OM": "Oman",
    "NL": "Paesi Bassi",
    "PK": "Pakistan",
    "PW": "Palau",
    "PA": "Panamá",
    "PG": "Papua Nuova Guinea",
    "PY": "Paraguay",
    "PE": "Perù",
    "PF": "Polinesia francese",
    "PL": "Polonia",
    "PT": "Portogallo",
    "PR": "Portorico",
    "XA": "pseudo-accenti",
    "XB": "pseudo-bidi",
    "QA": "Qatar",
    "HK": "RAS di Hong Kong",
    "MO": "RAS di Macao",
    "GB": "Regno Unito",
    "CF": "Repubblica Centrafricana",
    "DO": "Repubblica Dominicana",
    "RE": "Riunione",
    "RO": "Romania",
    "RW": "Ruanda",
    "RU": "Russia",
    "EH": "Sahara occidentale",
    "KN": "Saint Kitts e Nevis",
    "LC": "Saint Lucia",
    "MF": "Saint Martin",
    "VC": "Saint Vincent e Grenadine",
    "BL": "Saint-Barthélemy",
    "PM": "Saint-Pierre e Miquelon",
    "WS": "Samoa",
    "AS": "Samoa americane",
    "SM": "San Marino",
    "SH": "Sant’Elena",
    "ST": "São Tomé e Príncipe",
    "SN": "Senegal",
    "RS": "Serbia",
    "SC": "Seychelles",
    "SL": "Sierra Leone",
    "SG": "Singapore",
    "SX": "Sint Maarten",
    "SY": "Siria",
    "SK": "Slovacchia",
    "SI": "Slovenia",
    "SO": "Somalia",
    "ES": "Spagna",
    "LK": "Sri Lanka",
    "US": "Stati Uniti",
    "SS": "Sud Sudan",
    "ZA": "Sudafrica",
    "SD": "Sudan",
    "SR": "Suriname",
    "SJ": "Svalbard e Jan Mayen",
    "SE": "Svezia",
    "CH": "Svizzera",
    "SZ": "Swaziland",
    "TJ": "Tagikistan",
    "TW": "Taiwan",
    "TZ": "Tanzania",
    "TF": "Terre australi francesi",
    "PS": "Territori palestinesi",
    "IO": "Territorio britannico dell’Oceano Indiano",
    "TH": "Thailandia",
    "TL": "Timor Est",
    "TG": "Togo",
    "TK": "Tokelau",
    "TO": "Tonga",
    "TT": "Trinidad e Tobago",
    "TA": "Tristan da Cunha",
    "TN": "Tunisia",
    "TR": "Turchia",
    "TM": "Turkmenistan",
    "TV": "Tuvalu",
    "UA": "Ucraina",
    "UG": "Uganda",
    "HU": "Ungheria",
    "UY": "Uruguay",
    "UZ": "Uzbekistan",
    "VU": "Vanuatu",
    "VE": "Venezuela",
    "VN": "Vietnam",
    "WF": "Wallis e Futuna",
    "YE": "Yemen",
    "ZM": "Zambia",
    "ZW": "Zimbabwe"
  }
}
